export default "__VITE_ASSET__DabbXXWd__"